import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Label' })({
    root: {
        display: 'flex',
        padding: '12px 20px 12px 16px',
        alignItems: 'center',
        gap: 8,
        borderRadius: 12,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap'
    },
    icon: {
        display: 'flex',
        ['& svg']: {
            width: 16,
            height: 16
        }
    },
    count: {
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    _default: {
        color: '#232323',
        border: '1px solid #ECECEC',
        background: 'transparent'
    },
    _danger: {
        background: '#FF5342',
        color: '#FFEBED'
    },
    _compact: {
        padding: '4px 8px 4px 4px'
    }
});
